var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncrementButtonArr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35895 0.586957L13.4065 5.67391C14.0212 6.29348 14.1584 7.00239 13.818 7.80065C13.479 8.60022 12.8726 9 11.999 9L2.00101 9C1.1274 9 0.521045 8.60022 0.181954 7.80065C-0.158431 7.00239 -0.0212412 6.29348 0.593521 5.67391L5.64105 0.586957C5.83519 0.391304 6.0455 0.244567 6.27199 0.14674C6.49848 0.048914 6.74115 0 7 0C7.25885 0 7.50152 0.048914 7.72801 0.14674C7.9545 0.244567 8.16481 0.391304 8.35895 0.586957Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrementButtonArr);
export default __webpack_public_path__ + "static/media/IncrementButtonArr.eb9d31ef3e8ae140d2ba6627e941ce51.svg";
export { ForwardRef as ReactComponent };